<template>
  <div id="ShopCartProductCard" class="shop_cart_card">
    <div class="image_box">
      <img
        :src="$store.getters.imageUrl(shopCartData.imageData)"
        :alt="shopCartData.productData.Title"
      />
    </div>
    <div class="info_box">
      <div class="text_box">
        <div>
          <p class="product_title">{{ shopCartData.productData.Title }}</p>

          <p
            v-for="(option, optionIndex) in shopCartData.optionList"
            :key="`option_${optionIndex}`"
            class="option_box"
          >
            <span class="option_title">{{ option.Title }}</span>
            <span class="option_value">{{ option.Value }}</span>
          </p>
        </div>
        <button @click="shopCartData.minusAmount(-1)">
          <span class="material-symbols-rounded"> close </span>
        </button>
      </div>

      <div class="amount_price_box">
        <div class="amount_box">
          <button @click="shopCartData.minusAmount(1)">
            <span class="material-symbols-rounded"> remove </span>
          </button>
          <input
            type="number"
            min="1"
            :value="shopCartData.amount"
            @change="shopCartData.changeAmount($event.target.value)"
          />
          <button @click="shopCartData.addAmount()">
            <span class="material-symbols-rounded"> add </span>
          </button>
        </div>
        <p class="product_price">
          NT$ {{ $store.getters.moneyFormat(shopCartData.SellPrice()) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCartProductCard",
  props: {
    shopCartData: {
      type: Object,
    },
  },
};
</script>
